<div class="billing-plan-selector-shell">
  <div class="billing-plan-selector-page">
    <div *ngIf="awaitingPaymentConfirmation" class="pending-payment-wrap">
      <p class="pending-payment-text">{{ awaitingPaymentMessage || 'Waiting for payment confirmation...' }}</p>
      <mat-spinner *ngIf="!pendingConfirmationTimedOut" diameter="32" class="pending-payment-spinner"></mat-spinner>
      <div *ngIf="pendingConfirmationTimedOut" class="pending-payment-actions">
        <button mat-stroked-button color="primary" (click)="onRetryPendingStatus()">
          Check status again
        </button>
        <button mat-raised-button color="accent" (click)="onContactSupport()">
          Contact support
        </button>
      </div>
    </div>

    <ng-container *ngIf="!awaitingPaymentConfirmation">
      <ng-container *ngIf="step === 'plans'">
        <h1>Choose your billing plan</h1>
        <p class="subtitle">
          <span *ngIf="selectorScope === 'individual'">
            Pick a plan to continue:
          </span>
          <span *ngIf="selectorScope === 'team'">
            Set up your team billing to continue. Team tier is determined automatically by current active team size.
          </span>
        </p>

        <div *ngIf="loading" class="loading-wrap">
          <mat-spinner diameter="32"></mat-spinner>
          <span>{{ loadingMessage }}</span>
        </div>

        <div *ngIf="!loading && plans.length === 0" class="empty-state">
          <mat-icon>info</mat-icon>
          <span>{{ selectorScope === 'team' ? 'No team plan is currently available.' : 'No individual plans are currently available.' }}</span>
        </div>

        <section
          *ngIf="!loading && plans.length > 0"
          class="plan-grid"
          [class.plan-grid--single]="plans.length === 1"
          [class.plan-grid--double]="plans.length === 2">
          <mat-card class="plan-card" *ngFor="let plan of plans">
            <mat-card-header>
              <mat-card-title>{{ plan.displayName }}</mat-card-title>
              <mat-card-subtitle *ngIf="selectorScope === 'team'">{{ plan.planCode }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="plan-price" *ngIf="plan.planCode !== 'INDIVIDUAL_PAYG'; else paygPrice">
                R{{ (plan.displayMonthlyPriceCents / 100) | number:'1.0-0' }}
                <span>/month per user</span>
              </div>
              <ng-template #paygPrice>
                <div class="plan-price plan-price--payg">
                  R0
                  <span>/month</span>
                </div>
              </ng-template>
              <div class="plan-metadata" *ngIf="plan.highlights?.length; else defaultMeta">
                <div *ngFor="let highlight of plan.highlights">
                  <span>{{ highlight }}</span>
                </div>
              </div>
              <ng-template #defaultMeta>
                <div class="plan-metadata">
                  <div>
                    <strong>{{ plan.includedCreditsPerUser }}</strong>
                    <span>included credits / month</span>
                  </div>
                  <div>
                    <strong>R{{ (plan.topupCreditPriceCents / 100) | number:'1.2-2' }}</strong>
                    <span>per top-up credit</span>
                  </div>
                </div>
              </ng-template>
              <p class="plan-description">{{ plan.description }}</p>
            </mat-card-content>
            <mat-card-actions>
              <button
                mat-raised-button
                color="primary"
                (click)="onChoosePlan(plan)"
                [disabled]="selectingPlanCode !== null">
                {{ selectingPlanCode === plan.planCode ? 'Applying...' : (plan.planCode === 'INDIVIDUAL_PAYG' ? 'Continue' : 'Choose plan') }}
              </button>
            </mat-card-actions>
          </mat-card>
        </section>
      </ng-container>

      <ng-container *ngIf="step === 'packs'">
        <h1>Buy credits</h1>
        <p class="subtitle">
          Pick a pack now, or skip and top up later from your Account Info screen.
        </p>

        <div *ngIf="loading" class="loading-wrap">
          <mat-spinner diameter="32"></mat-spinner>
          <span>{{ loadingMessage }}</span>
        </div>

        <app-topup-pack-cards
          *ngIf="!loading"
          [packs]="topupPackOptions"
          [selectedPackSize]="selectedTopupPack"
          [disabled]="purchasingTopup"
          [showSkip]="true"
          [buyLabel]="purchasingTopup ? 'Opening...' : 'Buy credits'"
          (selectedPackSizeChange)="onSelectedPackChange($event)"
          (buy)="onBuyPackCredits($event)"
          (skip)="onSkipPacks()">
        </app-topup-pack-cards>
      </ng-container>
    </ng-container>
  </div>
</div>
